import {
  AccountHistoryPage,
  AccountRequisitesPage,
  AccountsPage,
  AccountStatementPage,
} from "@/modules/account/pages";
import { FeatureToggle } from "@/shared/common/enums";
import { FeatureToggleRoute } from "@/shared/components";
import { Layout } from "@/shared/layout";
import type { RouteObject } from "react-router-dom";

enum Paths {
  Accounts = "accounts",
  AccountHistory = ":accountId/history",
  AccountStatement = ":accountId/statement",
  AccountRequisites = ":accountId/requisites",
}

export const accountRoutes: RouteObject = {
  path: Paths.Accounts,
  element: <Layout/>,
  handle: {
    breadcrumb: () => ({ key: "breadcrumb.accounts" })
  },
  children: [
    { path: "", element: <AccountsPage/> },
    {
      path: Paths.AccountHistory,
      element: <AccountHistoryPage/>,
      handle: {
        breadcrumb: () => ({
          key: "breadcrumb.accountHistory",
        })
      }
    },
    {
      path: Paths.AccountStatement,
      element: (
        <FeatureToggleRoute
          featureFlag={FeatureToggle.isAccountStatementAvailable}
          element={<AccountStatementPage/>}
        />
      ),
      handle: {
        breadcrumb: () => ({
          key: "breadcrumb.accountStatement",
        })
      },
    },
    {
      path: Paths.AccountRequisites,
      element: (
        <FeatureToggleRoute
          featureFlag={FeatureToggle.isAccountRequisiteAvailable}
          element={<AccountRequisitesPage/>}
        />
      ),
      handle: {
        breadcrumb: () => ({
          key: "breadcrumb.accountRequisites",
        })
      },
    },
  ],
};
